// schemas/shared.ts
import { z } from 'zod';
import mongoose from "mongoose";

export const zBaseDocument = z.object({
    _id: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
    __v: z.number().optional(),
})

// ObjectId or string for MongoDB
export const objectIdSchema = z.union([
    z.string().refine((val) => mongoose.Types.ObjectId.isValid(val), {
        message: "Invalid ObjectId string",
    }),
    z.instanceof(mongoose.Types.ObjectId)
]);

const objectIdSchemaLong = z.any().refine((val) => {
    if (typeof val === 'string') return mongoose.Types.ObjectId.isValid(val);
    if (val instanceof mongoose.Types.ObjectId) return true;
    return false;
}, {
    message: "Must be a valid ObjectId or ObjectId string"
});

// ObjectId-like schema (string or actual ObjectId if you transform it)
export const objectIdSchemaSmall = z.string().min(1);


export const zDateField = z.union([
    z.string().refine((val) => !isNaN(Date.parse(val)), {
        message: 'Invalid date string'
    }),
    z.date()
]);

export const zConsentSchema = z.object({
    accepted: z.boolean().default(false),
    acceptedDate: z.string().datetime().nullable().optional()
}).superRefine((data, ctx) => {
    if (data.accepted && !data.acceptedDate) {
        // Set acceptedDate automatically if missing
        data.acceptedDate = new Date().toISOString();
    }
});
export type ZConsentSchema = z.infer<typeof zConsentSchema>;
export const zDocumentConsentSchema = z.object({
    accepted: z.boolean().default(false),
    acceptedDate: z.string().datetime().nullable().optional(),
    documentVersion: z.string().default("0"),
    documentDate: z.string().datetime().nullable().optional()
}).superRefine((data, ctx) => {
    if (data.accepted && !data.acceptedDate) {
        // Set acceptedDate automatically if missing
        data.acceptedDate = new Date().toISOString();
    }
});
export type ZDocumentConsentData = z.infer<typeof zDocumentConsentSchema>;






